import React from 'react';
import appStoreBadge from '@assets/app-store-badge.svg';
import googlePlayBadge from '@assets/google-play-badge.svg';
import { ModalBox, useModalContext } from '@fourthwall/components';
import { MOBILE_APP_ANDROID_LINK, MOBILE_APP_IOS_LINK } from '@fourthwall/utils/dist/links';
import code from './assets/code.png';
import * as S from './styled';
export const GetFourthwallAppModal = () => {
    const modal = useModalContext();
    return (React.createElement(ModalBox, { title: "Get the Fourthwall app", size: "small", onClose: modal.close },
        React.createElement("p", null, "Scan with your phone to download:"),
        React.createElement(S.Container, null,
            React.createElement(S.QRCode, { src: code, alt: "Code" }),
            React.createElement(S.Links, null,
                React.createElement("div", null,
                    React.createElement("a", { href: MOBILE_APP_IOS_LINK, target: "_blank", rel: "noreferrer" },
                        React.createElement("img", { src: appStoreBadge, alt: "App Store Badge" }))),
                React.createElement("div", null,
                    React.createElement("a", { href: MOBILE_APP_ANDROID_LINK, target: "_blank", rel: "noreferrer" },
                        React.createElement("img", { src: googlePlayBadge, alt: "Google Play Badge" })))))));
};
